<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <div class="select-label">订单编号:</div>
      <Input v-model="orderId" style="width:150px;" placeholder="请输入小程序名称" :rows="4" />
    </div>
    <div class="select-box input_left_four">
      <!-- <div class="select-label">订单时间:</div> -->
      <DatePicker v-model="timeArr" type="daterange" format="yyyy-MM-dd" placeholder="请选择订单时间" style="width: 200px" />
    </div>
    <div class="select-box input_left_two">
      <div class="select-label">小程序名称:</div>
      <Select v-model="storePkgName" style="width:100px" @on-change="changeAppList">
        <Option v-for="item in appList" :value="item.package_name" :key="item.id">{{ item.name }}</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn"  style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear" >重置</Button>
    </div>
    <Table :loading="tableLoading" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
    <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../https'
export default {
  name: 'testUsers',
  data () {
    return {
      loading: true,
      timeArr: [],
      storePkgName: '',
      tableLoading: true,
      orderId: '',
      appList: [],
      columns: [ // table表格
        {
          title: '订单编号',
          key: 'orderNo',
          width: 150,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '应用名称',
          key: 'businessName',
          align: 'center',
          minWidth: 200
        },
        {
          title: '支付时间',
          align: 'center',
          key: 'updateDate',
          minWidth: 100
        },
        {
          title: '渠道',
          align: 'center',
          key: 'brand',
          minWidth: 100
        },
        {
          title: '订单交易金额',
          align: 'center',
          key: 'purchAmount',
          minWidth: 100
        },
        {
          title: '佣金比例',
          align: 'center',
          key: 'incomeRate',
          minWidth: 100
        },
        {
          title: '预估佣金金额',
          align: 'center',
          key: 'incomeMoney',
          minWidth: 100
        },
        {
          title: '订单状态',
          align: 'center',
          key: 'refundOrderStatus',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.refundOrderStatus === 0) {
              return h('span', {
                style: {
                  width: '100px',
                  height: '50px',
                  textAlign: 'center',
                  lineHeight: '50px'
                }
              }, '订单完成')
            } else if (params.row.apk_type === 1) {
              return h('span', {
                style: {
                  width: '100px',
                  height: '50px',
                  textAlign: 'center',
                  lineHeight: '50px'
                }
              }, '已退款')
            }
          }
        },
        {
          title: '退款时间',
          align: 'center',
          key: 'refundUpdTime',
          minWidth: 100
        },
        {
          title: '退款金额',
          align: 'refundMoney',
          key: 'remark',
          minWidth: 100
        }
        // {
        //   title: '更新时间',
        //   key: 'updated_at',
        //   minWidth: 200
        // }
      ],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1 // 当前页
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      // return
    }
    this.getAccount()
    this.getDay(-7)
    setTimeout(() => {
      this.loadData()
    }, 500)
  },
  methods: {
    // 加载tabs列表
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.orderId = ''
      this.timeArr = []
      this.storePkgName = ''
      this.loadData()
    },
    getAccount () {
      https.request({
        method: 'GET',
        url: '/v2/es/account',
        params: {}
      }).then(res => {
        this.getAppList(res.id)
      })
    },
    getAppList (id) {
      let params = {
        page_size: 100,
        page: 1,
        uid: id
      }
      https.request({
        method: 'get',
        url: 'v2/es/apps',
        params: params
      }).then(res => {
        this.appList = res.data.items
        this.storePkgName = res.data.items[0].package_name
      })
    },
    changeAppList (val) {
      this.storePkgName = val
    },
    loadData () {
      if (this.timeArr.length === 0) {
        this.$Message.error('请选择查询日期')
        return
      }
      let params = {
        page: this.current,
        page_size: this.pageSize,
        s_date: '',
        e_date: '',
        order_id: this.orderId,
        store_pkg_name: this.storePkgName
      }
      let year = this.timeArr[0].getFullYear()
      let month = this.timeArr[0].getMonth() + 1 < 10 ? `0${this.timeArr[0].getMonth() + 1}` : this.timeArr[0].getMonth() + 1
      let day = this.timeArr[0].getDate() < 10 ? `0${this.timeArr[0].getDate()}` : this.timeArr[0].getDate()
      let yearE = this.timeArr[1].getFullYear()
      let monthE = this.timeArr[1].getMonth() + 1 < 10 ? `0${this.timeArr[1].getMonth() + 1}` : this.timeArr[1].getMonth() + 1
      let dayE = this.timeArr[1].getDate() < 10 ? `0${this.timeArr[1].getDate()}` : this.timeArr[1].getDate()
      params.s_date = `${year}-${month}-${day}`
      params.e_date = `${yearE}-${monthE}-${dayE}`
      console.log(params)
      https.request({
        method: 'get',
        url: '/v2/es/order/details',
        params: params
      }).then(res => {
        this.dataList = res.data.records
        this.tableLoading = false
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    // 数据静态分页
    setData () {
      this.dataList = []
      this.total = this.dataSource.length
      for (let i = (this.current - 1) * this.pageSize; i < this.current * this.pageSize; i++) {
        if (i === this.total) return false
        this.dataList.push(this.dataSource[i])
      }
    },
    // 表格排序
    sortChange (data) {
      if (data.order !== 'normal') {
        this.sort = [data.key, data.order].join(' ')
        this.loadData()
      }
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    // 每页条数控制
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    getDay (day) {
      let today = new Date()
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day
      today.setTime(targetday_milliseconds)
      this.timeArr = [today, new Date()]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .spacingTwice{
    margin-top:30px;
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    left: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
    .input_left{
    // left:516px;
    left:131px;
  }
  .input_left_two{
    // left:700px;
    left:588px;
  }
  .input_left_three{
    // left:885px;
    left:781px;
  }
  .input_left_four{
    left:369px;
  }
</style>



// WEBPACK FOOTER //
// src/components/payDetails.vue